export class NewUser {
    email = ''
    password = ''
    username = ''
    error = false
    errorMsg: string | null = null
}
